import React from 'react';
import {Route} from 'react-router-dom';
import AsyncPage from './async';
import DefaultBusinessLayout from '../../../../components/layout/DefaultBusinessLayout';

export default [
  <Route
    key="/business/technologies/agile-face"
    element={<DefaultBusinessLayout isEnterprise={true} />}
  >
    <Route path="business/technologies/agile-face" element={<AsyncPage />} />
  </Route>,
];
